import React, { useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import { SettingsItem } from 'design-system';
import { IconGoal } from 'design-system/icons';
import { IconBomb } from 'design-system/icons/IconBomb';
import { IconEnergyBolt } from 'design-system/icons/IconEnergyBolt';
import { useAppSelector } from 'store/hooks';
import { SellOrderType } from '../types';
import { selectActiveTradingAccountId } from '../reducers/selectors';
const SelectSellOrderTypeModalContent = ({ symbol, assetId, closeModal, onSelectOrderType, }) => {
    const accountId = useAppSelector(selectActiveTradingAccountId);
    const availableToSell = useAppSelector((state) => (accountId ? state.invest.tradingAccountPositionsCache?.[accountId]?.[assetId]?.availableToSell : 0) || 0);
    const hasWholePosition = availableToSell ? !!Math.floor(availableToSell) : false;
    const handleSelect = useCallback((orderType) => () => {
        onSelectOrderType(orderType);
        closeModal();
    }, [closeModal, onSelectOrderType]);
    return (<>
      <SettingsItem titleFirst title="Market order" onPress={handleSelect(SellOrderType.MARKET)} icon={<IconEnergyBolt gradientKey="darkPurple"/>} description={`Sell $${symbol} at the current market price.`}/>
      <View style={!hasWholePosition && styles.disabled} testID="LimitOrderRow">
        <SettingsItem titleFirst title="Limit order" disabled={!hasWholePosition} icon={<IconGoal gradientKey="orange"/>} onPress={handleSelect(SellOrderType.LIMIT)} description={<Text TextThin-14 Secondary>
              Sell ${symbol} if it rises to a higher price.
              {hasWholePosition ? ('') : (<Text TextThin-14 Red>
                  {' '}
                  You need to own at least one whole share to place an order.
                </Text>)}
            </Text>}/>
      </View>
      <View style={!hasWholePosition && styles.disabled} testID="StopOrderRow">
        <SettingsItem titleFirst title="Stop order" icon={<IconBomb />} disabled={!hasWholePosition} onPress={handleSelect(SellOrderType.STOP)} description={<Text TextThin-14 Secondary>
              Sell ${symbol} if it falls to a lower price.
              {hasWholePosition ? ('') : (<Text TextThin-14 Red>
                  {' '}
                  You need to own at least one whole share to place an order.
                </Text>)}
            </Text>}/>
      </View>
    </>);
};
export default SelectSellOrderTypeModalContent;
const styles = StyleSheet.create({
    disabled: {
        opacity: 0.5,
    },
});
